/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import adduser from '../../../images/ic_Leaderboard.png';
import { endpointDataInterface } from '../../viewAllEndpoint/allEndpointBody';
import subFunction from '../helpers';
import BaseUrls from '../../../utils/baseUrls';
import { prefixPath } from '../../../utils/helpers';

interface customData extends endpointDataInterface {
    cardnumber: number,
    total: number,
    card_type?: 'workspace' | 'endpointlist',
}
const EndpointCard = ({
  id,
  type,
  name,
  frontendBaseSuburl,
  protocolName,
  createdAt,
  viewableLabels,
  plan,
  cardnumber,
  total,
  card_type = 'endpointlist',
}: customData) => {
  const setImage = (val: string) => {
    if (val.includes(' ')) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      val = val.split(' ')[1];
    }
    switch (val.toLowerCase()) {
      case 'corda': return './images/protocols/logos/corda_logo.svg';
      case 'ethereum': return './images/protocols/logos/ethereum_logo.svg';
      case 'credit': return './images/protocols/logos/credits.png';
      case 'fabric': return './images/protocols/logos/Hyperledger-Fabric_logo.svg';
      case 'sawtooth': return './images/protocols/logos/sawtooth_logo.svg';
      case 'fluree': return './images/protocols/logos/fluree_logo.svg';
      case 'phaeton': return './images/protocols/logos/phaeton_logo.svg';
      case 'polygon': return './images/protocols/logos/Polygonpos_logo.svg';
      case 'binance': return './images/protocols/logos/binance_logo.svg';
      case 'tron': return './images/protocols/logos/tron_logo.svg';
      case 'avalanche': return './images/protocols/logos/avalanche_logo.svg';
      case 'axia': return './images/protocols/logos/axia_logo.svg';
      case 'fantom': return './images/protocols/logos/Fantom_logo.svg';
      case 'dcomm': return './images/protocols/logos/dcommdark_logo.svg';
      case 'polkadot': return './images/protocols/logos/Polkadot_logo.svg';
      case 'okc': return './images/protocols/logos/okc_logo.svg';
      case 'aptos': return './images/protocols/logos/Aptos_logo.svg';
      case 'coreum': return './images/protocols/logos/Coreum_logo.svg';
      case 'shardeum': return './images/protocols/logos/Shardeum_logo.svg';
      case 'energy-web': return './images/protocols/logos/Energy_Web_Logo.svg';
      case 'enterprise': return './images/protocols/logos/corda_logo.svg';
      case 'avalanche-subnets': return './images/protocols/logos/avalanche_logo.svg';
      case 'blockchain': return './images/protocols/logos/provenance_blockchain_logo.svg';
      case 'bahamut': return './images/protocols/logos/fastex_logo.svg';
      case 'zksyncera': return './images/protocols/logos/zksyncera_logo.svg';
      case 'opstack': return './images/protocols/logos/opstack_logo.svg';
      case 'shido': return './images/protocols/logos/shido_logo.svg';
      case 'subsquid': return './images/protocols/logos/subsquid-logo-dark.svg';

      default: return '';
    }
  };
  const theme = BaseUrls.getkey();
  const baseUrl = window.location.origin;
  const activeNodeImg = baseUrl + prefixPath(`/img/${theme}/active-nodes.png`);
  const inActiveNodeImg = baseUrl + prefixPath(`/img/${theme}/inactive-nodes.png`);
  return (
        <div className="col-lg-4 col-xl-3 col-md-6 col-sm-12 mt-5 ">
            <div className="card workSpaceCard" style={{ height: '100%' }}>
                <div className="card-body">
                    <div className="d-flex justify-content-between">
                        <div className="col-10">
                            <img
                                src={`${card_type === 'workspace' ? '.' : ''}${setImage(protocolName)}`}
                                height="30px"
                                alt=""
                            />
                        </div>
                        <div className="d-flex justify-content-end">
                            <div className="square2 rounded-2 px-2 cursor" onClick={() => { subFunction('action', cardnumber, total); }}>
                                <i className="fas fa-ellipsis-v mx-2" />
                                <ul
                                    className="dropdown-menu collapse bg-card "
                                    aria-labelledby=""
                                    id={`action${cardnumber}`}
                                >
                                    <li>
                                        <a href={`${frontendBaseSuburl}/endpoints/${id}`} className="dropdown-item" type="">
                                            {' '}
                                            <img className="mx-2" src={adduser} alt="" />
                                            View RPC Endpoint
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4 mb-4">
                        <div className="col-xl-8 col-7 col-md-4">
                            <a href={`${frontendBaseSuburl}/endpoints/${id}`} className="workspaceCardHeading" style={{ textDecoration: 'none' }}>
                                {' '}
                                <strong className="">{name}</strong>
                                {' '}
                            </a>
                        </div>
                        <span className="col-3 badge text-center">Endpoint</span>
                    </div>
                    <div className="mt-3 mb-1 a-tag">
                        <div className="d-flex align-items-center">
                            <div className="col-2">
                                <img className="px-1" src={inActiveNodeImg} alt="" />
                            </div>
                            <div className="col-6 my-auto ms-1">Plan Type</div>
                            <div className="col-4 mx-auto">
                                <strong>{plan}</strong>
                            </div>
                        </div>
                    </div>
                    {
                        Object.keys(viewableLabels).map((key) => (
                            <div className="mt-3 mb-1 a-tag" key={key}>
                          <div className="d-flex align-items-center">
                              <div className="col-2">
                                  <img className="px-1" src={activeNodeImg} alt="" />
                              </div>
                              <div className="col-6 my-auto ms-1">{key}</div>
                              <div className="col-4 mx-auto">
                                  <strong>{viewableLabels[key]}</strong>
                              </div>
                          </div>
                            </div>
                        ))
                      }
                </div>
                <div className="card-footer a-tag">
                    <div className="d-flex">
                        <div className="col-11">
                            <p className="create m-auto mt-1">
                                Created on
                                {' '}
                                {(new Date(createdAt || '')).toDateString()}
                            </p>
                        </div>
                        <div className="col-2">
                            {/* <img
                                    data-bs-toggle="tooltip"
                                    title="Process Cancel"
                                    src={statuscancel}
                                    alt=""
                                /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

  );
};

export default EndpointCard;
